/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { AdComposedPlayer } from '@quickplay/player-interface';
import { BroadpeakAdsSessionData } from './BroadpeakAdsSession';
import { PALSession } from '@quickplay/pal';

/**
 * Supported Broadpeak ad view states.
 */
export enum AdViewState {
  NORMAL = 'normal',
  MINIMIZED = 'minimized',
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
  FULLSCREEN = 'fullscreen',
}

export interface BroadpeakAdsPlayer extends AdComposedPlayer, PALSession {
  /**
   * Broadpeak ads session associated with this player instance.
   * Provides access to session data and ad-related functionality.
   */
  broadpeakSession: BroadpeakAdsSessionData;

  /**
   * Updates the current ad view state.
   *
   * This should be called after setting the ad view and whenever the
   * player view state changes.
   *
   * Supported states:
   * - `normal` - Default player state.
   * - `minimized` - Player is minimized or not visible.
   * - `collapsed` - Player view is reduced in size.
   * - `expanded` - Player view is expanded.
   * - `fullscreen` - Player is displayed in fullscreen mode.
   *
   * @param state The current ad view state.
   */
  setAdViewState(state: AdViewState): void;
}
